import { render, staticRenderFns } from "./materialGRIDetail.vue?vue&type=template&id=193fb260&scoped=true"
import script from "./materialGRIDetail.vue?vue&type=script&lang=js"
export * from "./materialGRIDetail.vue?vue&type=script&lang=js"
import style0 from "./materialGRIDetail.vue?vue&type=style&index=0&id=193fb260&lang=scss&scoped=true"
import style1 from "./materialGRIDetail.vue?vue&type=style&index=1&id=193fb260&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193fb260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('193fb260')) {
      api.createRecord('193fb260', component.options)
    } else {
      api.reload('193fb260', component.options)
    }
    module.hot.accept("./materialGRIDetail.vue?vue&type=template&id=193fb260&scoped=true", function () {
      api.rerender('193fb260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/material/material-master-data/materialGRIDetail.vue"
export default component.exports